import ApiDrivenModel from "./ApiDrivenModel";
import { Cache } from "../util/Cache.util";
import LiveApiClient from "../api/LiveApiClient";

const LIVE_PLUS_TYPES = new Set(["live-plus", "connect-supplier"]);

export default class Catalog extends ApiDrivenModel {
	static OFFLINE = true;
	static CACHE_TTL = 14400; // 4 hours

	static Is_Live_Plus(catalog) {
		return LIVE_PLUS_TYPES.has(catalog?.account?.type?.code?.toLowerCase());
	}

	static Is_Retailer_Only_Branded(catalog) {
		return this.Override_Brand_Branding(catalog);
	}
	
	static Override_Brand_Branding(catalog) {
		return !!catalog?.options?.branding?.override_brand;
	}

	static Is_Add_Proposal_Allowed(catalog) {
		return !this.Is_Live_Plus(catalog);
	}
	
	static IsPublic(catalog) {
		return catalog?.options?.type?.toLowerCase() === "public";
	}

	static async Has_B2c_Catalog() {
		const cachedValue = Cache.Local().get("has-b2c-catalog");
		if (cachedValue) {
			return true;
		}

		const catalog = await LiveApiClient.get('Catalog_Invitation', {
			headers: { 'api-key': 1 },
			params: {
				paths: JSON.stringify({
					catalog: {
						status: true,
						options: ["type"],
					}
				}),
				filter: JSON.stringify([
					{ property: "{is_accepted}", value: 1 },
					{ property: "{catalog.options.type}", value: "b2c" },
				]),
				limit: 1
			}
		}).then(r => r.data.at(0)?.catalog)

		if (catalog) {
			Cache.Local().set("has-b2c-catalog", "true");
		}

		return !!catalog;
	}


	static ENDPOINT = "/Catalog";
	static SEARCH_PATHS = {
		id: true,
		name: true,
	};
}
